export default __webpack_public_path__ + "static/media/skoda.b29934a2.png";